import { render, staticRenderFns } from "./ReasonsRejection.vue?vue&type=template&id=10ecee95&scoped=true"
import script from "./ReasonsRejection.vue?vue&type=script&lang=js"
export * from "./ReasonsRejection.vue?vue&type=script&lang=js"
import style0 from "./ReasonsRejection.vue?vue&type=style&index=0&id=10ecee95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ecee95",
  null
  
)

export default component.exports